import React from "react";
// Icons, shared data, primitives for Onboarding prototype
const { useState, useEffect, useRef, useMemo } = React;

// ---------- Icons (Lucide-style) ----------
const _s = { fill: "none", stroke: "currentColor", strokeWidth: 1.75, strokeLinecap: "round", strokeLinejoin: "round" };
const Svg = ({ size = 20, children }) => <svg viewBox="0 0 24 24" width={size} height={size} {..._s}>{children}</svg>;
const IcCheck = ({size=16}) => <Svg size={size}><path d="M20 6 9 17l-5-5"/></Svg>;
const IcArrow = ({size=14}) => <Svg size={size}><path d="M5 12h14M13 5l7 7-7 7"/></Svg>;
const IcBack = ({size=14}) => <Svg size={size}><path d="M19 12H5M11 19l-7-7 7-7"/></Svg>;
const IcUpRight = ({size=14}) => <Svg size={size}><path d="M7 17 17 7M7 7h10v10"/></Svg>;
const IcDownload = ({size=16}) => <Svg size={size}><path d="M12 3v14M5 10l7 7 7-7M5 21h14"/></Svg>;
const IcSearch = ({size=16}) => <Svg size={size}><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></Svg>;
const IcPin = ({size=16}) => <Svg size={size}><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></Svg>;
const IcBed = ({size=14}) => <Svg size={size}><path d="M2 9V4h4M22 9V4h-4M2 15v5h4M22 15v5h-4M4 9v6a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4V9"/></Svg>;
const IcBath = ({size=14}) => <Svg size={size}><path d="M9 6 6.5 3.5a1.77 1.77 0 0 0-2.7 2.35L5 7M2 12h20v2a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5Zm2-5V5"/></Svg>;
const IcSq = ({size=14}) => <Svg size={size}><path d="M3 3h18v18H3z M9 3v18 M3 9h18"/></Svg>;
const IcLock = ({size=14}) => <Svg size={size}><rect x="4" y="11" width="16" height="10" rx="1"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></Svg>;
const IcUser = ({size=16}) => <Svg size={size}><circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/></Svg>;
const IcMail = ({size=16}) => <Svg size={size}><rect x="3" y="5" width="18" height="14" rx="1"/><path d="m3 7 9 6 9-6"/></Svg>;
const IcPhone = ({size=16}) => <Svg size={size}><path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3.1-8.7A2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.3 1.8.6 2.6a2 2 0 0 1-.5 2.1L8 9.7a16 16 0 0 0 6 6l1.3-1.2a2 2 0 0 1 2.1-.5c.8.3 1.7.5 2.6.6a2 2 0 0 1 1.7 2Z"/></Svg>;
const IcEdit = ({size=14}) => <Svg size={size}><path d="M17 3a2.83 2.83 0 0 1 4 4L7.5 20.5 2 22l1.5-5.5Z"/></Svg>;
const IcSend = ({size=14}) => <Svg size={size}><path d="M22 2 11 13M22 2l-7 20-4-9-9-4 20-7Z"/></Svg>;
const IcX = ({size=16}) => <Svg size={size}><path d="M18 6 6 18M6 6l12 12"/></Svg>;
const IcDoc = ({size=16}) => <Svg size={size}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8ZM14 2v6h6M8 13h8M8 17h5"/></Svg>;
const IcShield = ({size=16}) => <Svg size={size}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z"/><path d="m9 12 2 2 4-4"/></Svg>;
const IcBuilding = ({size=16}) => <Svg size={size}><rect x="4" y="2" width="16" height="20" rx="1"/><path d="M9 22v-4h6v4M8 6h.01M16 6h.01M8 10h.01M16 10h.01M8 14h.01M16 14h.01"/></Svg>;
const IcHome = ({size=16}) => <Svg size={size}><path d="M3 10.5 12 3l9 7.5V21a1 1 0 0 1-1 1h-5v-7H9v7H4a1 1 0 0 1-1-1Z"/></Svg>;
const IcExternal = ({size=14}) => <Svg size={size}><path d="M15 3h6v6M10 14 21 3M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/></Svg>;
const IcRefresh = ({size=14}) => <Svg size={size}><path d="M3 12a9 9 0 0 1 15-6.7L21 8M21 3v5h-5M21 12a9 9 0 0 1-15 6.7L3 16M3 21v-5h5"/></Svg>;
const IcClock = ({size=14}) => <Svg size={size}><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></Svg>;
const IcBranch = ({size=16}) => <Svg size={size}><circle cx="6" cy="3" r="2"/><circle cx="18" cy="6" r="2"/><circle cx="12" cy="21" r="2"/><path d="M6 5v6a4 4 0 0 0 4 4h2M18 8v1a4 4 0 0 1-4 4h-2M12 13v6"/></Svg>;
const IcSpark = ({size=14}) => <Svg size={size}><path d="m12 3 2 5 5 2-5 2-2 5-2-5-5-2 5-2Z"/></Svg>;
const IcKey = ({size=16}) => <Svg size={size}><circle cx="7.5" cy="15.5" r="4.5"/><path d="m10.7 12.3 8.3-8.3M16 7l3 3M14 9l3 3"/></Svg>;
const IcHandshake = ({size=16}) => <Svg size={size}><path d="m11 17 2 2a1 1 0 0 0 3-3M2 12l3-3 4 4 3-3 6 6M9 13l2 2M2 12V7a1 1 0 0 1 1-1h3l3 3"/></Svg>;
const IcEscrow = ({size=16}) => <Svg size={size}><rect x="3" y="8" width="18" height="12" rx="1"/><path d="M3 8 12 3l9 5M8 14h8M12 11v6"/></Svg>;

// ---------- Data ----------
const AGENT = {
  name: "Morgan Castellano",
  email: "morgan.castellano@gmail.com",
  phone: "(602) 555-0164",
  license: "SA12345678",
  mlsId: "1203451",
  currentBroker: "My Home Group LLC",
  photo: null, // placeholder
};

// ---------- Brokerage transfer parties (single source of truth) ----------
// These are FIXED for every transfer the app generates. Change them here and the
// document fill, routing, and audit records update everywhere.
//
//   • LISTING_AGENT        — the agent of record on EVERY transferred listing.
//                            George Laughton is always the Listing Agent; the
//                            agent going through onboarding is the CO-LIST agent.
//   • RECEIVING_BROKERAGE  — the brokerage receiving the listings/escrows/BBAs.
//   • TRANSFERRING_BROKERAGE — the brokerage releasing them.
const LISTING_AGENT = {
  name: "George Laughton",
  license: "SA579470000",  // George's ADRE license #
  mlsId: "gl139",          // George's ARMLS member/agent ID
};
const RECEIVING_BROKERAGE = "EveryPlace";        // new / receiving listing broker
const TRANSFERRING_BROKERAGE = "My Home Group LLC"; // original / releasing broker

// The transferring (onboarding) agent always rides along as the CO-LIST agent.
function coListAgent(agent) {
  return { name: (agent && agent.name) || AGENT.name, license: (agent && agent.license) || AGENT.license };
}

const LISTINGS = [
  {
    id: "L1",
    mls: "6812493",
    addr: "1842 E Desert Willow Dr",
    city: "Chandler, AZ 85286",
    price: "$845,000",
    beds: 3, baths: 2, sqft: "2,140",
    status: "Active",
    dom: 14,
    seller: { name: "Lauren & Paul Hilliard", email: "lhilliard@gmail.com", phone: "(480) 555-0142" },
    fubMatch: { confidence: "high", pct: 98 },
    transferStatus: "draft",
    assoc: "weserv",   // Chandler — SE Valley
  },
  {
    id: "L2",
    mls: "6810772",
    addr: "504 N Saguaro Ln",
    city: "Paradise Valley, AZ 85253",
    price: "$1,295,000",
    beds: 4, baths: 3, sqft: "3,010",
    status: "Active",
    dom: 31,
    seller: { name: "B.K. Cheshire", email: "bk.cheshire@outlook.com", phone: "(602) 555-0198" },
    fubMatch: { confidence: "high", pct: 96 },
    transferStatus: "draft",
    assoc: "saar",     // Paradise Valley — Scottsdale
  },
  {
    id: "L3",
    mls: "6814102",
    addr: "2217 W Camelback Rd",
    city: "Phoenix, AZ 85015",
    price: "$610,000",
    beds: 3, baths: 2, sqft: "1,780",
    status: "Active · Coming Soon",
    dom: 2,
    seller: { name: "Nina & Rob Caldwell", email: "ncaldwell@icloud.com", phone: "(623) 555-0117" },
    fubMatch: { confidence: "med", pct: 74 },
    transferStatus: "draft",
    assoc: "phx",      // Phoenix — PAR
  },
  {
    id: "L4",
    mls: "6805329",
    addr: "78 W Pepper Tree Ct",
    city: "Gilbert, AZ 85295",
    price: "$725,000",
    beds: 4, baths: 2.5, sqft: "2,430",
    status: "Active",
    dom: 22,
    seller: { name: "Deborah LeBlanc", email: "", phone: "(480) 555-0206" },
    fubMatch: { confidence: "low", pct: 52 },
    transferStatus: "draft",
    assoc: "weserv",   // Gilbert — SE Valley
  },
];

// ---------- Listing Transfer Authorization forms (per REALTOR association) ----------
// Each association uses its own "Authorization to Transfer Listing" form. Source PDFs
// live in the brokerage Drive (Listing Transfer Forms). `url` links the official PDF;
// `sigOrder` / `submitTo` / `note` mirror each association's actual form so the in-app
// preview matches what the seller and brokers will sign.
const LISTING_TRANSFER_FORMS = {
  weserv: {
    short: "WeSERV", name: "West & SouthEast REALTORS\u00AE of the Valley",
    formTitle: "Listing Transfer Authorization",
    submitTo: "Fax 623.931.1008 or membership@weserv.realtor",
    sigOrder: ["Seller (1)", "Seller (2)", "Original Listing Broker", "New Listing Broker", "Listing Agent", "Co-Listing Agent"],
    url: "https://drive.google.com/file/d/1U1kTAUcwl9n4i51nUCKN_Snivgi6hhXB/view",
  },
  saar: {
    short: "SAAR", name: "Scottsdale Area Association of REALTORS\u00AE",
    formTitle: "Authorization to Transfer Listing Form",
    submitTo: "8600 E Anderson Dr, Ste 200, Scottsdale \u00B7 info@ScottsdaleREALTORS.org",
    note: "Submit with the REALTOR\u00AE Member Change Form when active listings are transferring.",
    sigOrder: ["Seller", "Seller", "Original Listing Broker", "New Listing Broker", "Listing Agent", "Co-Listing Agent"],
    url: "https://drive.google.com/file/d/1EagIURiCw_ShDes1pL_rAJoRCHfYyK1z/view",
  },
  phx: {
    short: "PAR", name: "Phoenix REALTORS\u00AE",
    formTitle: "Listing Transfer Authorization Form",
    submitTo: "membership@phoenixrealtors.com",
    note: "Listings are assets of the original listing broker's firm \u2014 the original listing broker (authorized representative) signs first.",
    sigOrder: ["Original Listing Broker (Authorized Signature & Title)", "New Listing Broker", "Seller", "Seller", "Listing Agent", "Co-Listing Agent"],
    url: "https://drive.google.com/file/d/1nZw8BdofcgaXazZeNXO03CI62-OFXipZ/view",
  },
  tar: {
    short: "TAR", name: "Tucson Association of REALTORS\u00AE \u00B7 MLSSAZ",
    formTitle: "Listing Transfer Form",
    submitTo: "MLSSAZ \u2014 Southern Arizona",
    sigOrder: ["Seller", "Co-Seller", "(From) Listing Broker", "(To) Listing Broker", "Listing Agent", "Co-Listing Agent"],
    url: "https://drive.google.com/file/d/1QT6uPUQOn0beNfO97IJiQtezSpm1rn34/view",
  },
  naar: {
    short: "NAAR", name: "Northern Arizona Association of REALTORS\u00AE",
    formTitle: "Authorization to Transfer Listings",
    submitTo: "NAAR \u00B7 copies to original & new broker, seller(s), agent",
    sigOrder: ["Seller", "Seller", "Original Listing Broker", "New Listing Broker", "Listing Agent", "Co-Listing Agent"],
    url: "https://drive.google.com/file/d/160Q5MfUZtZJ4YoybzKigtPKnABX20ysi/view",
  },
  paar: {
    short: "PAAR", name: "Prescott Area Association of REALTORS\u00AE",
    formTitle: "Authorization to Transfer Listing",
    submitTo: "PAAR \u00B7 copies to original & new listing broker, seller(s), new agent",
    sigOrder: ["Seller", "Seller", "Original Listing Broker", "New Listing Broker", "Listing Agent", "Co-Listing Agent"],
    url: "https://drive.google.com/file/d/1x8mHKU8N4r40IIic1OEBeySQ4bN-uQHw/view",
  },
  wmar: {
    short: "WMAR", name: "West Maricopa Association of REALTORS\u00AE",
    formTitle: "Listing Transfer Authorization",
    submitTo: "WMAR \u00B7 wmar@wmaronline.com",
    sigOrder: ["Listing Agent", "Seller 1", "Seller 2", "Receiving Broker", "Transferring Broker"],
    url: "https://wmaronline.com",
  },
};

function listingFormFor(assoc) {
  return LISTING_TRANSFER_FORMS[assoc] || LISTING_TRANSFER_FORMS.weserv;
}

// ---------- Logo ----------
function EPLogo({ height = 22, dark = false }) {
  return (
    <img src="assets/logos/EP_Wordmark.svg" alt="EveryPlace"
      style={{ height, filter: dark ? "none" : "brightness(0) invert(1)", display: "block" }}/>
  );
}

// Inline wordmark — use anywhere "EveryPlace" would appear in running text.
// Scales to the surrounding font-size so baseline and weight match the line.
function EPInline({ dark = true, style = {} }) {
  return (
    <img src="assets/logos/EP_Wordmark.svg" alt="EveryPlace"
      style={{
        height: "0.78em",
        verticalAlign: "baseline",
        transform: "translateY(0.04em)",
        display: "inline-block",
        filter: dark ? "none" : "brightness(0) invert(1)",
        ...style,
      }}/>
  );
}

// ---------- Status pill ----------
function StatusPill({ status }) {
  const map = {
    draft:       { cls: "draft", label: "Draft" },
    review:      { cls: "pending", label: "Ready to Review" },
    sent_owner:  { cls: "sent", label: "Sent to Owner" },
    sent_broker: { cls: "sent", label: "Sent to Broker" },
    sent_parties:{ cls: "sent", label: "Out for Signature" },
    countersign: { cls: "pending", label: "Awaiting Brokers" },
    signed:      { cls: "signed", label: "Signed" },
    transferred: { cls: "complete", label: "Transferred" },
  };
  const s = map[status] || map.draft;
  return <span className={`ep-badge ${s.cls}`}>{s.label}</span>;
}

// ---------- Confidence pill ----------
function ConfidencePill({ confidence, pct }) {
  const map = { high: "High match", med: "Review match", low: "Low match" };
  return <span className={`conf ${confidence}`}><IcSpark size={11}/> {map[confidence]} · {pct}%</span>;
}

// ---------- Data-state banner ----------
// Renders the loading / not-connected / error state for a server-backed step
// (listings, escrows, bbas). Distinguishes a not-yet-connected upstream (Spark /
// Brokermint / FUB — an expected pre-provisioning state) from a transient error,
// and offers a retry that re-hits the same GET.
function DataState({ loading, error, onReload, noun }) {
  if (loading) {
    return (
      <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "14px 18px", marginBottom: 20,
        background: "var(--ep-bg-elevated)", border: "1px solid var(--ep-border)", borderRadius: 2,
        color: "var(--ep-fg-muted)", fontSize: 14 }}>
        <IcRefresh size={14}/> Loading your {noun}…
      </div>
    );
  }
  if (error) {
    const notConnected = error.status === 412 ||
      ["spark_not_connected", "fub_not_configured"].includes(error.code);
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16,
        padding: "14px 18px", marginBottom: 20,
        background: notConnected ? "#FFFAF0" : "#FDF2E9",
        border: `1px solid ${notConnected ? "var(--ep-border)" : "var(--ep-sunset)"}`, borderRadius: 2 }}>
        <div>
          <div style={{ font: "500 14px/1.3 var(--ep-font-body)", color: "var(--ep-origin)" }}>
            {notConnected ? `Your ${noun} aren't available yet` : `Couldn't load your ${noun}`}
          </div>
          <div style={{ fontSize: 12, color: "var(--ep-fg-muted)", marginTop: 2 }}>
            {notConnected
              ? `We'll pull your ${noun} once the feed is connected. You can continue and come back to this step.`
              : (error.message || "Something went wrong.")}
          </div>
        </div>
        {onReload && <button className="ep-btn ghost sm" onClick={() => onReload()}><IcRefresh size={12}/> Retry</button>}
      </div>
    );
  }
  return null;
}

export {
  DataState,
  IcCheck, IcArrow, IcBack, IcUpRight, IcDownload, IcSearch, IcPin, IcBed, IcBath, IcSq,
  IcLock, IcUser, IcMail, IcPhone, IcEdit, IcSend, IcX, IcDoc, IcShield, IcBuilding, IcHome,
  IcExternal, IcRefresh, IcClock, IcBranch, IcSpark, IcKey, IcHandshake, IcEscrow,
  EPLogo, EPInline, StatusPill, ConfidencePill, AGENT, LISTINGS,
  LISTING_TRANSFER_FORMS, listingFormFor,
  LISTING_AGENT, RECEIVING_BROKERAGE, TRANSFERRING_BROKERAGE, coListAgent,
};
